module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "left searchBtn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showUpBox(null)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("添加规格组")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.addressData.length > 10
    }
  }, _vm._l((_vm.addressData), function(item) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "20%",
        "text-align": "left",
        "padding-left": "10%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "40%",
        "text-align": "left",
        "padding-left": "10%"
      }
    }, [_c('span', [_vm._v(_vm._s((item.specs && Array.isArray(item.specs)) ? item.specs.join("、") : ""))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%",
        "text-align": "left",
        "padding-left": "10%"
      }
    }, [_c('span', [_vm._v(_vm._s(item.defaultSpec))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%",
        "text-align": "right",
        "padding-right": "10%"
      }
    }, [(item.id) ? _c('span', {
      staticStyle: {
        "margin": "0 2%",
        "cursor": "pointer"
      },
      attrs: {
        "title": "修改"
      },
      on: {
        "click": function($event) {
          return _vm.showUpBox(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-bianji"
    })]) : _vm._e(), _vm._v(" "), (item.id) ? _c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.delAddr(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-icon1460188478041"
    })]) : _vm._e()])])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": '添加/编辑规格组',
      "visible": _vm.addAddrBtn,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.addAddrBtn = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("规格组名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入规格组名称"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("添加规格")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autoSpec),
      expression: "autoSpec"
    }],
    staticClass: "left itemInput",
    staticStyle: {
      "width": "57.89%"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入规格..."
    },
    domProps: {
      "value": (_vm.autoSpec)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.autoSpec = $event.target.value
      }
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.modifySpec('add')
      }
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), (_vm.specs && Array.isArray(_vm.specs) && _vm.specs.length) ? _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("已添加规格")]), _vm._v(" "), _vm._l((_vm.specs), function(tag, index) {
    return _c('el-tag', {
      key: ("_" + index),
      staticStyle: {
        "margin": "5px"
      },
      attrs: {
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.modifySpec('del', index)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(tag) + "\n                    ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("默认规格")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.defaultSpec),
      callback: function($$v) {
        _vm.defaultSpec = $$v
      },
      expression: "defaultSpec"
    }
  }, _vm._l((_vm.specs), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addAddrBtn = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addAddrFn
    }
  }, [_vm._v("保存")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "20%",
      "text-align": "left",
      "padding-left": "10%"
    }
  }, [_vm._v("规格组名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%",
      "text-align": "left",
      "padding-left": "10%"
    }
  }, [_vm._v("所含规格")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%",
      "text-align": "left",
      "padding-left": "10%"
    }
  }, [_vm._v("默认规格")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%",
      "text-align": "right",
      "padding-right": "10%"
    }
  }, [_vm._v("操作")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-b9810d7e","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/indexRouters/goods/spec.vue
// module id = 979
// module chunks = 1